import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { NavigationItem } from '../../../models/common';
import { ActionSheetService } from '../../../services/action-sheet/action-sheet.service';
import { ClaimService } from '../../../services/claim/claim.service';
import { FeatureFlagService } from '../../../services/feature-flag/feature-flag.service';
import { ResponsiveService } from '../../../services/responsive/responsive.service';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { LsqBaseNavigationComponent } from '../base-navigation/lsq-base-navigation.component';

@Component({
    selector: 'lsq-mobile-navigation',
    templateUrl: './lsq-mobile-navigation.component.html',
    styleUrls: ['./lsq-mobile-navigation.component.scss']
})
export class LsqMobileNavigationComponent extends LsqBaseNavigationComponent {
    @Input() public navigationItems: NavigationItem[] = [];
    @Output() public close = new EventEmitter();

    constructor(
        public actionSheetService: ActionSheetService,
        protected userService: UserService,
        @Inject(SETTINGS) protected settings: ISettings,
        protected router: Router,
        public featureFlagService: FeatureFlagService,
        public claimService: ClaimService,
        public responsiveService: ResponsiveService
    ) {
        super(userService, settings, router, featureFlagService, claimService, responsiveService);
    }

    public closeActionSheet(): void {
        this.actionSheetService.closeActionSheet();
    }
}
